import { useState, useCallback } from 'react'
import { useDashboard } from './useDashboard'

interface UseGiveUpReturn {
  isLoading: boolean
  error: string | null
  submit: (geoId: number, amount: number) => Promise<boolean>
  clearError: () => void
}

export function useGiveUp(): UseGiveUpReturn {
  const { giveUpCap } = useDashboard()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const submit = useCallback(
    async (geoId: number, amount: number): Promise<boolean> => {
      setIsLoading(true)
      setError(null)
      try {
        await giveUpCap(geoId, amount)
        return true
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to give up cap')
        return false
      } finally {
        setIsLoading(false)
      }
    },
    [giveUpCap]
  )

  const clearError = useCallback(() => setError(null), [])

  return { isLoading, error, submit, clearError }
}
